<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div class="page-content">

  <span class="red-text">{{getString(errorMessage)}}</span>

  <app-choose-username *ngIf="showUsernameForm" (onSuccess)="register($event)"></app-choose-username>

</div>